import React from 'react';
import { Link } from 'react-router-dom';
import { Trophy } from 'lucide-react';
import './sports.css';

// Spor bölümü açık ama hiçbir oran kaynağı (ve hazır spor kitabı) yayında
// değilken çizilir. Sayfa eskiden boş bir lig rayı, "Spor veri servisi henüz
// yapılandırılmadı" ve "konsensüs oran kaynağı" gibi teknik cümleler
// gösteriyordu: oyuncuya yapacak bir şey vermeyen, kurulumun iç yapısını
// anlatan metinler (bkz. CLAUDE.md → *Açılış hatasının sebebi oyuncuya
// yazılmaz*). Kararı ``useSportsbook().unavailable`` verir.
const SportsUnavailable = () => (
  <div className="sb-unavailable" role="status">
    <span className="sb-unavailable-icon" aria-hidden="true">
      <Trophy size={28} />
    </span>
    <h1 className="sb-unavailable-title">Spor bahisleri şu anda kullanılamıyor</h1>
    <p className="sb-unavailable-text">
      Spor bölümümüz geçici olarak hizmet dışı. Lütfen daha sonra tekrar deneyin.
    </p>
    <Link to="/" className="sb-unavailable-link">Ana Sayfaya Dön</Link>
  </div>
);

export default SportsUnavailable;
